import { parseISO } from 'date-fns';
import type {
  ContentObjectWithingsOrderPostDataObject,
  ProgramWithingsOrderPostContentObjectDetailDataObject,
  ProgramWithingsOrderPostContentObjectListDataObject,
  WithingsOrderPostContentObjectDetailDataObject,
  WithingsOrderPostContentObjectListDataObject,
} from '../../service';
import { type ProgramContentObject, createProgramContentObject } from '../contentable-type-content-objects';

export type ContentObjectWithingsOrderPost = {
  htmlContent?: string;
  id: string;
  textContent?: string;
  title?: string;
  todoDueDate?: Date;
};

export const createContentObjectWithingsOrderPost = (
  data: ContentObjectWithingsOrderPostDataObject,
): ContentObjectWithingsOrderPost => ({
  htmlContent: data.html_content,
  id: data.id ?? '',
  textContent: data.text_content,
  title: data.title,
  todoDueDate: data.todo_due_date ? parseISO(data.todo_due_date) : undefined,
});

export type ProgramWithingsOrderPostContentObjectDetail = {
  filledWithingsOrder: boolean;
  type: 'withings_order_post';
  withings_order_post: ContentObjectWithingsOrderPost;
} & ProgramContentObject;

export type ProgramWithingsOrderPostContentObjectList = {
  filledWithingsOrder: boolean;
  type: 'withings_order_post';
  withings_order_post: ContentObjectWithingsOrderPost;
} & ProgramContentObject;

export type WithingsOrderPostContentObjectDetail = ProgramWithingsOrderPostContentObjectDetail;

export type WithingsOrderPostContentObjectList = ProgramWithingsOrderPostContentObjectList;

export const createProgramWithingsOrderPostContentObjectDetail = (
  data: ProgramWithingsOrderPostContentObjectDetailDataObject,
): ProgramWithingsOrderPostContentObjectDetail => ({
  ...createProgramContentObject(data),
  filledWithingsOrder: Boolean(data.filled_withings_order),
  type: 'withings_order_post',
  // eslint-disable-next-line @typescript-eslint/naming-convention -- widely relied on as-is across frozen queries/hooks and tests; renaming is a separate, larger cleanup
  withings_order_post: createContentObjectWithingsOrderPost(data.withings_order_post),
});

/* eslint-disable sonarjs/no-identical-functions -- Detail and List factories are intentionally symmetric; their DataObject shapes are expected to diverge */
export const createProgramWithingsOrderPostContentObjectList = (
  data: ProgramWithingsOrderPostContentObjectListDataObject,
): ProgramWithingsOrderPostContentObjectList => ({
  ...createProgramContentObject(data),
  filledWithingsOrder: Boolean(data.filled_withings_order),
  type: 'withings_order_post',
  // eslint-disable-next-line @typescript-eslint/naming-convention -- widely relied on as-is across frozen queries/hooks and tests; renaming is a separate, larger cleanup
  withings_order_post: createContentObjectWithingsOrderPost(data.withings_order_post),
});
/* eslint-enable sonarjs/no-identical-functions -- end of symmetric factory */

export const createWithingsOrderPostContentObjectDetail = (
  data: WithingsOrderPostContentObjectDetailDataObject,
): WithingsOrderPostContentObjectDetail => createProgramWithingsOrderPostContentObjectDetail(data);

export const createWithingsOrderPostContentObjectList = (
  data: WithingsOrderPostContentObjectListDataObject,
): WithingsOrderPostContentObjectList => createProgramWithingsOrderPostContentObjectList(data);
